import React from 'react';
import {
  Box,
  FieldWrapper,
  FormPreloader,
  FormTitle,
  Inscription,
  Label,
} from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledList = styled.ul`
  list-style: inherit;
  padding-left: ${({ theme }) => theme.spacings.l};
`;

const EMPTY_FIELD_VALUE = 'This entity is not yet applied to any role.';

interface Props {
  roles?: string[];
  isModalMode?: boolean;
  isLoading?: boolean;
}
const AppliedTo: React.FC<Props> = ({
  roles,
  isModalMode,
  isLoading,
}) => {
  return (
    <Box>
      <FormTitle>Applied to</FormTitle>
      {isLoading ? (
        <FormPreloader testId="preloader" count={4} />
      ) : (
        <Box direction="column">
          <FieldWrapper margin={{ bottom: 'm', top: isModalMode ? '' : 'm' }} align="start">
            <Label
              name="roles"
              isNarrow={isModalMode}
            >
              Roles
            </Label>

            {(roles && roles.length) ? (
              <Box>
                <StyledList>
                  {roles.map((role) => (
                    <li data-testid={`field-level-access-role_${role}`} key={role}>
                      <Inscription size="medium">{role}</Inscription>
                    </li>
                  ))}
                </StyledList>
              </Box>
            ) : 
              (
                <Inscription data-testid="field-level-access-roles_empty">
                  {EMPTY_FIELD_VALUE}
                </Inscription>
              )}
          </FieldWrapper>
        </Box>
      )}
    </Box>
  );
};

export default AppliedTo;